import { apiRequest } from "./client";
import { SettingsItem, SettingsUpdatePayload } from "../types/settings.types";

export const getSettingsRequest = async (): Promise<SettingsItem> => {
    return apiRequest<SettingsItem>("/settings", {
        method: "GET",
        auth: true,
    });
};

export const updateSettingsRequest = async (
    payload: SettingsUpdatePayload
): Promise<SettingsItem> => {
    return apiRequest<SettingsItem>("/settings", {
        method: "PATCH",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
        },
        auth: true,
    });
};
